// extracted by mini-css-extract-plugin
module.exports = {"root":"Counter_root__10CTZ","activeElement":"Counter_activeElement__3U0c1","disabledElement":"Counter_disabledElement__3fVky","input":"Counter_input__v12Uo"};